package com.ragnorak.clanybackoffice.ui.screens

import androidx.lifecycle.ViewModel
import dev.zacsweers.metro.Inject

class SettingsViewModel @Inject constructor() : ViewModel()
